import React from 'react';
import { noop } from '@yme/utils/common';
import { DEFAULT_STATE, EMPTY_STATE, ARROW_STATE } from './constants';
import { PaginationInnerStyled, PaginationDefaultItemStyled, PaginationEmptyItemStyled, PaginationArrowsItemStyled, } from './styled';
/**
 * Pagination Item element
 * @param type - possible options: EMPTY_STATE | DEFAULT_STATE (DEFAULT_STATE by default)
 * @param children - optional prop; React Element (icons with arrows or ellipsis) or number of each item of Pagination
 * @param isActive - optional prop; (for styles)
 * @param isDisabled - optional prop (for styles)
 * @param onClick - optional prop (for element event); Default - noop
 *
 * @returns JSX.Element or null
 */
export function PaginationItem(props) {
    const { type = DEFAULT_STATE, children, isActive, isDisabled, isRightToLeft, onClick = noop, } = props;
    if (type === EMPTY_STATE && children) {
        return (React.createElement(PaginationEmptyItemStyled, null,
            React.createElement(PaginationInnerStyled, null, children)));
    }
    if (type === ARROW_STATE && children) {
        return (React.createElement(PaginationArrowsItemStyled, { isRightToLeft: isRightToLeft, isDisabled: isDisabled, onClick: onClick },
            React.createElement(PaginationInnerStyled, null, children)));
    }
    if (children) {
        return (React.createElement(PaginationDefaultItemStyled, { isActive: isActive, onClick: onClick },
            React.createElement(PaginationInnerStyled, null, children)));
    }
    return null;
}
PaginationItem.displayName = 'PaginationItem';
